export function identity(x) {
    return x;
}
export function isDataMap(obj) {
    return !!obj && typeof obj === 'object' && !Array.isArray(obj);
}
export var isDevelopment = function () { return typeof process !== 'undefined' && process.env.NODE_ENV !== 'production'; };
export function assertDataMap(obj, name) {
    if (!isDataMap(obj)) {
        if (isDevelopment()) {
            throw TypeError("'" + name + "' should be an object");
        }
        return false;
    }
    return true;
}
//# sourceMappingURL=utils.js.map